<template>
  <div class="page contact-page">
    <div class="loader" v-if="loading" aria-live="polite">
      <img src="@/assets/logo.png" alt="Nyenyezia Forex" class="logo-loader" />
      <img src="@/assets/03-42-05-37_512.webp" alt="" class="loader-loader" />
    </div>

    <section class="contact-hero">
      <div class="hero-content">
        <p class="eyebrow">Nyenyezia Forex</p>
        <h1>{{ isEnglish ? 'Contact Us' : 'Contactez-nous' }}</h1>
        <p>
          {{ isEnglish
            ? 'Send a request before confirming an exchange, transfer, or service question.'
            : 'Envoyez une demande avant de confirmer un change, un transfert ou une question de service.' }}
        </p>
      </div>
    </section>

    <main class="contact-shell">
      <section class="contact-panel">
        <div class="form-card">
          <p class="eyebrow">{{ isEnglish ? 'Message' : 'Message' }}</p>
          <h2>{{ isEnglish ? 'Send Us a Message' : 'Envoyez-nous un message' }}</h2>

          <div v-if="notice.text" class="form-notice" :class="notice.type">
            {{ notice.text }}
          </div>

          <form @submit.prevent="submitForm">
            <label class="form-group">
              <span>{{ isEnglish ? 'Full name' : 'Nom complet' }}</span>
              <input
                type="text"
                v-model="form.name"
                :placeholder="isEnglish ? 'Your full name' : 'Votre nom complet'"
                autocomplete="name"
                required
              />
            </label>

            <label class="form-group">
              <span>{{ isEnglish ? 'Email address' : 'Adresse email' }}</span>
              <input
                type="email"
                v-model="form.email"
                :placeholder="isEnglish ? 'you@example.com' : 'vous@exemple.com'"
                autocomplete="email"
                required
              />
            </label>

            <label class="form-group">
              <span>{{ isEnglish ? 'Subject' : 'Sujet' }}</span>
              <select v-model="form.subject">
                <option value="">{{ isEnglish ? 'Choose a subject (optional)' : 'Choisir un sujet (optionnel)' }}</option>
                <option value="Information">{{ isEnglish ? 'Currency Exchange' : 'Échange de devises' }}</option>
                <option value="Consultation">Consultation</option>
                <option value="Transfert">{{ isEnglish ? 'Money Transfer' : 'Transfert' }}</option>
                <option value="Autres">{{ isEnglish ? 'Other' : 'Autres' }}</option>
              </select>
            </label>

            <label class="form-group">
              <span>{{ isEnglish ? 'Message' : 'Message' }}</span>
              <textarea
                v-model="form.message"
                :placeholder="isEnglish ? 'How can we help?' : 'Comment pouvons-nous vous aider ?'"
                required
              ></textarea>
            </label>

            <button type="submit" class="btn-submit" :disabled="loading">
              {{ loading ? (isEnglish ? 'Sending...' : 'Envoi...') : (isEnglish ? 'Send Message' : 'Envoyer le message') }}
            </button>
          </form>
        </div>

        <aside class="help-card">
          <p class="eyebrow">{{ isEnglish ? 'Quick help' : 'Aide rapide' }}</p>
          <h2>{{ isEnglish ? 'Reach the team' : 'Joindre l’équipe' }}</h2>
          <p class="help-copy">
            {{ isEnglish
              ? 'For exchange rates, cash availability, or transfer questions, contact us before visiting.'
              : 'Pour les taux, la disponibilité des devises ou les transferts, contactez-nous avant votre visite.' }}
          </p>

          <div class="details-list">
            <div class="detail-item">
              <span>{{ isEnglish ? 'Address' : 'Adresse' }}</span>
              <p>922 Maloney Est, local 3<br />Gatineau, QC, J8P 1H9<br />Canada</p>
            </div>
            <div class="detail-item">
              <span>{{ isEnglish ? 'Phone' : 'Téléphone' }}</span>
              <p><a href="tel:+5144000939">514-400-0939</a></p>
            </div>
            <div class="detail-item">
              <span>Email</span>
              <p><a href="mailto:info@nyenyeziaforex.com">info@nyenyeziaforex.com</a></p>
            </div>
          </div>

          <a class="quick-cta" href="mailto:info@nyenyeziaforex.com">
            {{ isEnglish ? 'Email Nyenyezia Forex' : 'Écrire à Nyenyezia Forex' }}
          </a>
        </aside>
      </section>
    </main>
  </div>
  <vue3-notify />
</template>

<script>
import axios from 'axios';
import { apiUrl } from '@/config/api';

export default {
  name: 'ContactPage',
  data() {
    return {
      loading: false,
      notice: {
        type: '',
        text: ''
      },
      form: {
        name: '',
        email: '',
        subject: '',
        message: ''
      }
    };
  },
  computed: {
    isEnglish() {
      return this.$route.path.startsWith('/en');
    }
  },
  methods: {
    async submitForm() {
      this.loading = true;
      this.notice = { type: '', text: '' };

      const data = JSON.stringify({
        nom: this.form.name,
        email: this.form.email,
        sujet: this.form.subject,
        message: this.form.message
      });

      const config = {
        method: 'post',
        url: apiUrl('/contact-message'),
        headers: {
          'Content-Type': 'application/json'
        },
        data
      };

      try {
        await axios(config);
        this.notice = {
          type: 'success',
          text: this.isEnglish ? 'Your message has been sent. The team will follow up as soon as possible.' : 'Votre message a bien été envoyé. L’équipe vous répondra dès que possible.'
        };
        this.$snotify.success(this.isEnglish ? 'Your message has been sent.' : 'Votre message a bien été envoyé.');
        this.form = { name: '', email: '', subject: '', message: '' };
      } catch (error) {
        console.error(error);
        this.notice = {
          type: 'error',
          text: this.isEnglish ? 'We could not send the message right now. Please try again or email us directly.' : 'Nous n’avons pas pu envoyer le message pour le moment. Réessayez ou écrivez-nous directement.'
        };
        this.$snotify.error(this.isEnglish ? 'An error occurred while sending the message.' : 'Erreur lors de l’envoi du message.');
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.contact-page {
  background: #f4f7fb;
  color: #172033;
}

.loader {
  background: rgba(0, 16, 65, 0.58);
  height: 100%;
  inset: 0;
  position: fixed;
  width: 100%;
  z-index: 100000;
}

.logo-loader,
.loader-loader {
  left: 50%;
  max-width: 90%;
  position: absolute;
  transform: translate(-50%, -50%);
  width: 180px;
}

.logo-loader {
  top: calc(50% - 48px);
  z-index: 10010;
}

.loader-loader {
  top: calc(50% + 52px);
  z-index: 10010;
}

.contact-hero {
  background:
    linear-gradient(90deg, rgba(0, 16, 65, 0.86), rgba(0, 122, 204, 0.56)),
    url('@/assets/contact.jpg');
  background-position: center;
  background-size: cover;
  color: white;
  padding: 88px 20px 76px;
}

.hero-content {
  margin: 0 auto;
  max-width: 1080px;
}

.hero-content h1 {
  font-size: clamp(2.1rem, 5vw, 4rem);
  line-height: 1.05;
  margin: 8px 0 14px;
}

.hero-content p {
  font-size: 1.08rem;
  line-height: 1.65;
  margin: 0;
  max-width: 650px;
}

.eyebrow {
  color: #45a5f6;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0;
  margin: 0 0 7px;
  text-transform: uppercase;
}

.contact-shell {
  margin: 0 auto;
  max-width: 1120px;
  padding: 42px 20px 78px;
}

.contact-panel {
  display: grid;
  gap: 24px;
  grid-template-columns: minmax(0, 1.35fr) minmax(300px, 0.65fr);
}

.form-card,
.help-card {
  background: #fff;
  border: 1px solid #dbe3ef;
  border-radius: 8px;
  box-shadow: 0 16px 36px rgba(0, 16, 65, 0.08);
  padding: 28px;
}

.form-card h2,
.help-card h2 {
  color: #001041;
  margin: 0 0 20px;
}

.form-card .eyebrow,
.help-card .eyebrow {
  color: #007acc;
}

.form-notice {
  border-radius: 8px;
  margin-bottom: 18px;
  padding: 13px 14px;
}

.form-notice.success {
  background: #eefbf3;
  border: 1px solid #b9e5c7;
  color: #166534;
}

.form-notice.error {
  background: #fff3f2;
  border: 1px solid #f0c3bd;
  color: #8b1e1e;
}

.form-group {
  display: block;
  margin-bottom: 18px;
}

.form-group span,
.detail-item span {
  color: #2d405d;
  display: block;
  font-size: 0.86rem;
  font-weight: 700;
  margin-bottom: 7px;
}

.form-group input,
.form-group select,
.form-group textarea {
  background: #fbfdff;
  border: 1px solid #cfd9e8;
  border-radius: 8px;
  box-sizing: border-box;
  color: #172033;
  font-size: 1rem;
  outline: none;
  padding: 14px 15px;
  transition: border-color 0.2s, box-shadow 0.2s;
  width: 100%;
}

.form-group textarea {
  min-height: 150px;
  resize: vertical;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  border-color: #007acc;
  box-shadow: 0 0 0 3px rgba(0, 122, 204, 0.14);
}

.btn-submit,
.quick-cta {
  align-items: center;
  background: #007acc;
  border: none;
  border-radius: 8px;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  font-size: 1rem;
  font-weight: 700;
  justify-content: center;
  min-height: 48px;
  padding: 0 18px;
  text-decoration: none;
}

.btn-submit {
  width: 100%;
}

.btn-submit:disabled {
  cursor: wait;
  opacity: 0.72;
}

.btn-submit:hover,
.quick-cta:hover {
  background: #005f9d;
}

.help-copy {
  color: #53647c;
  line-height: 1.6;
  margin: 0 0 22px;
}

.details-list {
  display: grid;
  gap: 14px;
  margin-bottom: 22px;
}

.detail-item {
  border-top: 1px solid #e5ebf3;
  padding-top: 14px;
}

.detail-item p {
  color: #172033;
  line-height: 1.55;
  margin: 0;
}

.detail-item a {
  color: #007acc;
  text-decoration: none;
}

.detail-item a:hover {
  text-decoration: underline;
}

@media (max-width: 860px) {
  .contact-panel {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .contact-hero {
    padding: 72px 18px 56px;
  }

  .contact-shell {
    padding: 24px 12px 56px;
  }

  .form-card,
  .help-card {
    padding: 20px;
  }
}
</style>
